/**
 * UK ↔ US search synonym expansion for London Basket.
 * Expands header/search form queries with OR terms; adds crawlable discovery links on search pages.
 * Does not replace Shopify search — only augments submitted queries.
 */
(function () {
  var SYNONYMS = {
    crisps: ["chips"],
    chips: ["crisps"],
    sweets: ["candy"],
    candy: ["sweets"],
    biscuits: ["cookies"],
    cookies: ["biscuits"],
    "fizzy drinks": ["soda", "pop"],
    soda: ["fizzy drinks"],
    aubergine: ["eggplant"],
    eggplant: ["aubergine"],
    courgette: ["zucchini"],
    zucchini: ["courgette"],
    "cooking sauce": ["simmer sauce"],
    "simmer sauce": ["cooking sauce"],
    squash: ["cordial"],
    cordial: ["squash"],
    "chocolate bars": ["candy bars"],
    "candy bars": ["chocolate bars"],
    tinned: ["canned"],
    canned: ["tinned"],
  };

  function normalize(term) {
    return String(term || "")
      .toLowerCase()
      .trim()
      .replace(/\s+/g, " ");
  }

  function expandQuery(raw) {
    var q = String(raw || "").trim();
    if (!q || q.indexOf("lb-category:") === 0 || q.indexOf("vendor:") === 0) return q;

    var lower = normalize(q);
    var terms = [q];
    var extras = SYNONYMS[lower];
    if (extras) {
      extras.forEach(function (alt) {
        if (terms.indexOf(alt) === -1) terms.push(alt);
      });
    }

    Object.keys(SYNONYMS).forEach(function (uk) {
      if (lower.indexOf(uk) !== -1) {
        SYNONYMS[uk].forEach(function (alt) {
          var replaced = q.replace(new RegExp(uk, "ig"), alt);
          if (replaced && terms.indexOf(replaced) === -1) terms.push(replaced);
        });
      }
    });

    if (terms.length === 1) return q;
    return terms
      .map(function (t) {
        return t.indexOf(" ") !== -1 ? '"' + t + '"' : t;
      })
      .join(" OR ");
  }

  function enhanceForms() {
    document.querySelectorAll('form[action*="/search"]').forEach(function (form) {
      if (form.dataset.lbSynonyms === "true") return;
      form.dataset.lbSynonyms = "true";
      form.addEventListener("submit", function (e) {
        var input = form.querySelector('input[name="q"]');
        if (!input || !input.value.trim()) return;
        var expanded = expandQuery(input.value);
        if (expanded !== input.value.trim()) {
          input.value = expanded;
        }
      });
    });
  }

  function renderDiscovery() {
    var path = location.pathname.replace(/\/$/, "");
    if (path !== "/search") return;
    var params = new URLSearchParams(location.search);
    var q = (params.get("q") || "").trim();
    if (!q) return;

    var lower = normalize(q.replace(/"/g, ""));
    var alts = SYNONYMS[lower];
    if (!alts || !alts.length) return;

    var main = document.getElementById("MainContent");
    if (!main || document.getElementById("lb-search-synonyms")) return;

    var box = document.createElement("aside");
    box.id = "lb-search-synonyms";
    box.className = "lb-search-synonyms lb-container";
    box.setAttribute("aria-label", "Related search terms");

    var title = document.createElement("p");
    title.className = "lb-search-synonyms__title";
    title.textContent = "Also try searching for:";
    box.appendChild(title);

    var nav = document.createElement("nav");
    nav.className = "lb-search-synonyms__nav";
    alts.forEach(function (alt) {
      var a = document.createElement("a");
      a.href = "/search?type=product&q=" + encodeURIComponent(alt);
      a.textContent = alt;
      a.className = "lb-search-synonyms__link";
      nav.appendChild(a);
    });
    box.appendChild(nav);

    var h1 = main.querySelector("h1");
    if (h1 && h1.parentNode) {
      h1.parentNode.insertBefore(box, h1.nextSibling);
    } else {
      main.insertBefore(box, main.firstChild);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      enhanceForms();
      renderDiscovery();
    });
  } else {
    enhanceForms();
    renderDiscovery();
  }
})();
